import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {

  // properties
  private titleSubject = new BehaviorSubject<string>('Dashboard');
  title$ = this.titleSubject.asObservable();

   constructor() { }

  setTitle(title: string) {
    this.titleSubject.next(title);
    document.title = title; // also sets browser tab title
  }
 
}
